// Theme: sandstorm-ui
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'sandstorm-ui',
  name: 'SANDSTORM UI',
  tagline: 'SANDSTORM UI',
  description: 'Paleta arida de areia dourada com interface seca e limpa.',
  category: 'system-core',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#2A2018', '#3A2E22', '#D4B483', '#F5F0E8'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-sandstorm-ui'
  },
  colorVars: {
    '--accent': '#D4B483',
    '--accent-foreground': '#2A2018',
    '--background': '#2A2018',
    '--border': '#8A7055',
    '--card': '#3A2E22',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F5F0E8',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2A2018',
    '--foreground': '#F5F0E8',
    '--hold-fill': '#D4B483',
    '--input': '#8A7055',
    '--modal-bg': '#2A2018',
    '--modal-border': '#8A7055',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A7055',
    '--muted-foreground': '#F5F0E8',
    '--nav-active': '#D4B483',
    '--nav-bg': '#3A2E22',
    '--popover': '#3A2E22',
    '--popover-foreground': '#F5F0E8',
    '--primary': '#D4B483',
    '--primary-foreground': '#2A2018',
    '--ring': '#D4B483',
    '--secondary': '#8A7055',
    '--secondary-foreground': '#F5F0E8',
    '--streak': '#D4B483',
    '--success': '#22c55e',
    '--success-foreground': '#2A2018',
    '--xp': '#D4B483',
    '--xp-bg': '#3A2E22'
  },
  resolvedVars: {
    '--accent': '#D4B483',
    '--accent-foreground': '#2A2018',
    '--accent-foreground-hsl': '27 27% 13%',
    '--accent-foreground-oklch': 'from #2A2018 l c h',
    '--accent-hsl': '36 49% 67%',
    '--accent-oklch': 'from #D4B483 l c h',
    '--background': '#2A2018',
    '--background-hsl': '27 27% 13%',
    '--background-oklch': 'from #2A2018 l c h',
    '--border': '#8A7055',
    '--border-hsl': '31 24% 44%',
    '--border-oklch': 'from #8A7055 l c h',
    '--border-w': '1px',
    '--card': '#3A2E22',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F5F0E8',
    '--card-foreground-hsl': '37 39% 94%',
    '--card-foreground-oklch': 'from #F5F0E8 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--card-hsl': '30 26% 18%',
    '--card-oklch': 'from #3A2E22 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2A2018',
    '--destructive-foreground-hsl': '27 27% 13%',
    '--destructive-foreground-oklch': 'from #2A2018 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F5F0E8',
    '--foreground-hsl': '37 39% 94%',
    '--foreground-oklch': 'from #F5F0E8 l c h',
    '--hold-fill': '#D4B483',
    '--hold-fill-hsl': '36 49% 67%',
    '--hold-fill-oklch': 'from #D4B483 l c h',
    '--input': '#8A7055',
    '--input-hsl': '31 24% 44%',
    '--input-oklch': 'from #8A7055 l c h',
    '--modal-bg': '#2A2018',
    '--modal-bg-hsl': '27 27% 13%',
    '--modal-bg-oklch': 'from #2A2018 l c h',
    '--modal-border': '#8A7055',
    '--modal-border-hsl': '31 24% 44%',
    '--modal-border-oklch': 'from #8A7055 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A7055',
    '--muted-foreground': '#F5F0E8',
    '--muted-foreground-hsl': '37 39% 94%',
    '--muted-foreground-oklch': 'from #F5F0E8 l c h',
    '--muted-hsl': '31 24% 44%',
    '--muted-oklch': 'from #8A7055 l c h',
    '--nav-active': '#D4B483',
    '--nav-active-hsl': '36 49% 67%',
    '--nav-active-oklch': 'from #D4B483 l c h',
    '--nav-bg': '#3A2E22',
    '--nav-bg-hsl': '30 26% 18%',
    '--nav-bg-oklch': 'from #3A2E22 l c h',
    '--popover': '#3A2E22',
    '--popover-foreground': '#F5F0E8',
    '--popover-foreground-hsl': '37 39% 94%',
    '--popover-foreground-oklch': 'from #F5F0E8 l c h',
    '--popover-hsl': '30 26% 18%',
    '--popover-oklch': 'from #3A2E22 l c h',
    '--primary': '#D4B483',
    '--primary-foreground': '#2A2018',
    '--primary-foreground-hsl': '27 27% 13%',
    '--primary-foreground-oklch': 'from #2A2018 l c h',
    '--primary-hsl': '36 49% 67%',
    '--primary-oklch': 'from #D4B483 l c h',
    '--radius': '10px',
    '--ring': '#D4B483',
    '--ring-hsl': '36 49% 67%',
    '--ring-oklch': 'from #D4B483 l c h',
    '--secondary': '#8A7055',
    '--secondary-foreground': '#F5F0E8',
    '--secondary-foreground-hsl': '37 39% 94%',
    '--secondary-foreground-oklch': 'from #F5F0E8 l c h',
    '--secondary-hsl': '31 24% 44%',
    '--secondary-oklch': 'from #8A7055 l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#D4B483',
    '--streak-hsl': '36 49% 67%',
    '--streak-oklch': 'from #D4B483 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#2A2018',
    '--success-foreground-hsl': '27 27% 13%',
    '--success-foreground-oklch': 'from #2A2018 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(36 49% 67% / 0.15)',
    '--xp': '#D4B483',
    '--xp-bg': '#3A2E22',
    '--xp-bg-hsl': '30 26% 18%',
    '--xp-bg-oklch': 'from #3A2E22 l c h',
    '--xp-hsl': '36 49% 67%',
    '--xp-oklch': 'from #D4B483 l c h'
  }
}
